import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from "react-router-dom";
//Material-UI
import CssBaseline from '@material-ui/core/CssBaseline';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import themeObject from './util/theme';
//Redux
import { Provider } from 'react-redux';
import store from './redux/store';
//Yandex Metrica
import { YMInitializer } from 'react-yandex-metrika';

import ScrollToTop from './util/ScrollToTop';

const theme = createTheme(themeObject);


ReactDOM.render(
  <React.StrictMode>
    <YMInitializer accounts={[85814108]} />
    <Router>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ScrollToTop />
          <App />
        </ThemeProvider>
      </Provider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
